
import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import * as yup from 'yup';

import { getTwitchAuthURL, openAuthWindow } from 'utils/twitch';
import User from 'store/models/User';
import AppState, { selectTwitchConfig, selectAuthConfig } from 'store/AppState';

import Modal, { ModalActions } from 'components/Modal';
import TextInput from 'components/forms/TextInput';
import { ErrorList } from 'components/forms/Error';
import Button, { TwitchButton } from 'components/Button';

const actions = {
  updateUser: User.actions.updateUser,
  closeModal: AppState.actions.closeModal,
  ...ModalActions,
}

const selector = state => {
  return {
    
  };
}

const schema = yup.object().shape({
  //username: yup.string().min(5).required(),
  email: yup.string().required(),
});

class ModalComponent extends React.Component {
  constructor(props) {
    super(props);
    let f = ['email'];
    this.state = {
      values: { ..._.reduce(f, (acc, e) => _.set(acc, e, ''), {}), email: props.user.email},
      errors: _.reduce(f, (acc, e) => _.set(acc, e, null), {}),
      edits: _.reduce(f, (acc, e) => _.set(acc, e, false), {}),
      saving: false,
    }
  }

  onChange = (e) => {
    this.setState({ 
      values: {...this.state.values, [e.target.name]: e.target.value},
      edits: {...this.state.edits, [e.target.name]: true}
    });
  }

  onSave = () => {
    let { twitch, user, updateUser } = this.props;
    let { values, edits, errors } = this.state;

    schema.validate(values, {abortEarly: false})
      .then(v => {
        this.setState({ saving: true });
        this.props.updateUser(user._id, v)
          .then(() => {
            this.setState({ saving: false });
            this.onSuccess();
          })
          .catch(err => this.setState({ 
            saving: false,
            errors: { server: err.message }
          }));
      })
      .catch(e => {
        this.setState({
          errors: _.reduce(e.inner, (acc, v) => _.set(acc, v.path, v.errors), {})
        })
      });
  }

  onSuccess = (e) => {
    if(_.get(this.props, 'data.to')) {
      this.navigateTo(_.get(this.props, 'data.to'));
    } else {
      this.props.onClose ? this.props.onClose() : null;
    }
  }

  render() {
    let { data } = this.props;
    let { values, errors, saving } = this.state;
    return (
      <Modal id="signupModal" className="s">
        <div className="modal-header">
           <h1>Welcome To HappyStreams!</h1>
           <h2>Enter your email so we can send you reports.</h2>
        </div>
        <div className="modal-content">
          <form>
            <ErrorList errors={errors} />
            <TextInput
              label="Email"
              name="email"
              value={values.email}
              errors={errors.email}
              onChange={this.onChange}/>
          </form>
        </div>
        <div className="modal-footer btn-group">
          <Button 
            onClick={this.onSave}
            disabled={saving}>Save</Button>
        </div>
      </Modal>);
  }
};
ModalComponent = connect(selector, actions)(ModalComponent);
export { ModalComponent as default }
